// ΔVΔVΔ: Filename will be download.csv
const downloadString = (string, filename = 'download.txt', blank = false, onDownload = () => {}) => {
    const link = document.createElement('a');
    link.setAttribute('href', string);
    link.setAttribute('download', filename);
    if (blank) link.setAttribute('target', '_blank');
    document.body.appendChild(link); // Required for FF
    link.click();
    onDownload({ href: string, download: filename, target: blank ? '_blank' : '' });
    link.remove(); //use to prevent re-download
    return null;
};
export { downloadString };

//Found here: https://www.aspsnippets.com/Articles/Automatically-download-PDF-File-using-JavaScript.aspx
const downloadFile = (url, fileName, onDownload) => {
    //Create XMLHTTP Request.
    var req = new XMLHttpRequest();
    req.open('GET', url, true);
    req.responseType = 'blob';
    req.onload = function () {
        //Convert the Byte Data to BLOB object.
        var blob = new Blob([req.response], { type: 'application/octetstream' });

        //Check the Browser type and download the File.
        var isIE = false || !!document.documentMode;
        if (isIE) {
            window.navigator.msSaveBlob(blob, fileName);
        } else {
            var url = window.URL || window.webkitURL;
            var link = url.createObjectURL(blob);
            var a = document.createElement('a');

            downloadString(link, fileName, false);
            // a.setAttribute("download", fileName);
            // a.setAttribute("href", link);
            // document.body.appendChild(a);
            // a.click();
            // document.body.removeChild(a);
        }
    };
    req.onerror = function () {};
    onDownload({ href: url, download: fileName, target: '_blank' });
    req.send();
};
export { downloadFile };
